import { UserRoundPenIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

export const SheetEmptyState = ({
  setResumeTab,
}: {
  setResumeTab?: () => void;
}) => {
  return (
    <div className="flex max-w-[524px] flex-col items-center gap-6">
      <UserRoundPenIcon className="h-20 w-20 stroke-[1px] text-slate-700" />
      <div className="flex flex-col items-center gap-4">
        <p className="text-lg font-semibold text-slate-700">
          No Laborup profile yet
        </p>
        <p className="text-center font-medium text-slate-700">
          {setResumeTab
            ? "This candidate hasn't filled out their profile in our platform. However, they have submitted their resume for you to review."
            : "This candidate hasn't filled out their profile in our platform."}
        </p>
        {setResumeTab && (
          <Button
            className="rounded-full"
            onClick={setResumeTab}
            variant="outline"
          >
            View resume
          </Button>
        )}
      </div>
    </div>
  );
};
